const zhCN = {
  statistic: '统计数据',
  
  registered: '在册用户',
  auth: '有权限',
  unauth: '无权限',

  todayRegistered: '今日人员',
  todayVisitor: '今日访客',
  enter: '进门',
  out: '出门',

  todayWarning: '今日预警',
  stranger: '陌生人',
  blacklist: '黑名单',

  device: '设备',
  online: '在线',
  outline: '离线',

  unitMan: '人',
  unitManTime: '人次',
  unitTime: '次',
  unitSet: '台',
  unitWan: '万',

  quickAccess: '快速访问',
  dashboards: '数据看板'
}
const enUS = {
  statistic: 'Statistical Data',
  
  registered: 'Registered',
  auth: 'Auth',
  unauth: 'Unauth',

  todayRegistered: 'Today\'s registered',
  todayVisitor: 'Today\'s visitor',
  enter: 'Enter',
  out: 'Out',

  todayWarning: 'Today\'s warning',
  stranger: 'Stranger',
  blacklist: 'Blacklist',

  device: 'Device',
  online: 'Online',
  outline: 'Outline',

  unitMan: 'man',
  unitManTime: 'man-time',
  unitTime: 'time',
  unitSet: 'set',
  unitWan: 'w',

  quickAccess: 'Quick Access',
  dashboards: 'Dashboards'
}

export default { zhCN, enUS }